import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

import './index.css'
import App from './App'
import { store } from './_helpers'
import './assets/scss/app.scss'

const hostname=window.location.hostname


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
// eslint-disable-next-line no-console
console.log(
  '%cHi friend! If you\'re having trouble, feel free to email us at %csupport team.',
  `
    background: url(http://stocksmapdev.capestart.com/static/media/logo.988240b2.png);
    background-position: 0 10px;
    background-repeat: no-repeat;
    background-size: 64px 64px;
    line-height: 64px;
    padding: 10px 0 10px 74px;
  `,
  'font-weight: bold'
)
if(hostname && hostname.indexOf('localhost')<=-1)
  console.log = () => {}
  